import * as types from '../../constants/ActionTypes';


export const getAttachment = action => ({
    type: types.GET_ATTACHMENT,
    ...action,
});

export const getAttachmentSuccess = response => ({
    type: types.GET_ATTACHMENT_SUCCESS,
    response,
});

export const getAttachmentError = (id, response) => ({
    type: types.GET_ATTACHMENT_ERROR,
    id,
    response,
});